import Button from "components/shared/button";
import Input, { InputType } from "components/shared/inputs/input";
import { useEffect, useState } from "react";
import { useDatasourceOptions } from "./";

type Props = {
  onBack: () => void;
  onSubmit: (data: Record<string, any>) => Promise<void>;
  initialData?: Record<string, any> | null;
};

const TraceWidgetForm: React.FC<Props> = ({ onBack, onSubmit: onSubmitProp, initialData }) => {
  const [title, setTitle] = useState("");
  const [datasource, setDatasource] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { datasourceOptions } = useDatasourceOptions();

  useEffect(() => {
    setTitle(String(initialData?.title ?? ""));
    setDatasource(String(initialData?.content ?? ""));
  }, [initialData]);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await onSubmitProp({
        type: "TraceWidget",
        title,
        content: datasource,
      });
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type="text"
            label="title"
            name="trace_widget_title"
            value={title}
            onChange={(e: any) => setTitle(String(e.target?.value ?? ""))}
          />
        </group>
      </group>

      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type={InputType.Select}
            label="content"
            name="trace_widget_content"
            value={datasource}
            options={datasourceOptions}
            onChange={(v: any) => setDatasource(String(v ?? ""))}
          />
        </group>
      </group>

      <group data-wrap="no" data-gap="10">
        <Button type="button" primary text="submit" onClick={handleSubmit} disabled={isLoading} />
        <Button type="button" text="back" onClick={onBack} disabled={isLoading} />
      </group>
    </>
  );
};

export default TraceWidgetForm;
